import { CSSProperties } from "@material-ui/core/styles/withStyles"
import { HourPicker } from "."
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

type Props = {
  start: string
  end: string
  onChange: ({ name, value }: { name: string; value?: string }) => void
  onBlur?: () => void
  disabled?: boolean
  size?: "small" | "default"
  inputLabelClass?: string
}

export function HourRangePicker(props: Props) {
  const { t } = useI18n()
  const {
    start,
    end,
    onChange,
    onBlur,
    disabled,
    size = "default",
    inputLabelClass,
  } = props

  const style = {
    "--padding-right":
      size === "default" ? "var(--spacing-xxl-2)" : "var(--spacing-xxl-3)",
    "--icon-size": size === "default" ? "var(--spacing-l)" : "var(--spacing-s)",
    "--icon-position-fix":
      size === "default" ? "var(--spacing-xs)" : "var(--spacing-xxs)",
    "--field-padding":
      size === "default" ? "var(--spacing-m)" : "var(--spacing-xs)",
    "--width": size === "default" ? "var(--spacing-xxl-3)" : "var(--spacing-m)",
  } as CSSProperties

  return (
    <div style={style} className={styles.wrapper} onBlur={onBlur}>
      <HourPicker
        fullWidth={false}
        disabled={disabled}
        name="start"
        value={start}
        onChange={onChange}
        selectClass={styles.select}
        label={t("hour.picker.start")}
        inputLabelClass={inputLabelClass}
      />
      <div className={styles.line} />
      <HourPicker
        fullWidth={false}
        disabled={disabled}
        name="end"
        value={end}
        onChange={onChange}
        selectClass={styles.select}
        label={t("hour.picker.end")}
        inputLabelClass={inputLabelClass}
      />
    </div>
  )
}

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .MuiSelect-selectMenu {
      font-size: 13px;
      text-overflow: unset;
    }
    .MuiSelect-outlined {
      padding-right: var(--padding-right);
    }
    .MuiSvgIcon-root {
      width: var(--icon-size);
      height: var(--icon-size);
      top: calc(50% - var(--icon-position-fix));
    }
    .MuiFormLabel-root[data-shrink="true"] {
      transform: scale(0.75) translate(19px, -7px);
    }
    .MuiInputLabel-outlined {
      transform: translate(10px, 10px) scale(1);
    }
  `,
  select: css`
    padding: var(--field-padding);
    width: var(--width);
  `,
  line: css`
    height: 0px;
    width: 12px;
    border-top: 1px solid black;
    color: var(--black);
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 24px 8px;
  `,
}
